import { compose } from 'recompose';
import apiInterceptor from '../../../../api/interceptor';
import ServiceInvoiceDetail from './ServiceInvoiceDetail';
import { salesInvoiceApi } from '../../../common/base.api';

const composedServiceInvoiceDetail = compose(apiInterceptor({ ...salesInvoiceApi }))(ServiceInvoiceDetail);

export default composedServiceInvoiceDetail;
